<template>
  <div>
    <div class="card-container">
      <div class="card-title">
        <!-- 设备看板 -->
      </div>
      <div class="card-content">
        <a-row class="panel-container">
          <a-col :span="6" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <div class="type-name">
                  <div>
                    <IconFont
                      type="iconshebeizongshu_huaban1"
                      style="font-size: 45px; margin-right: 10px;"
                    />
                  </div>
                  <div class="text-desc">
                    <div>
                      设备总数
                    </div>
                    <div class="type-num" title="1,323">
                      {{ ListNumber.productTotal }}
                    </div>
                  </div>
                </div>
                <!-- <div class="type-num" :title="statisticsObj.productNum">
                  {{ statisticsObj.productNum }}
                </div> -->
              </span>
            </a-row>
          </a-col>
          <a-col :span="6" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <div class="type-name">
                  <div>
                    <IconFont
                      type="iconyichangshebei_huaban1"
                      style="font-size: 45px; margin-right: 10px;"
                    />
                  </div>
                  <div class="text-desc">
                    <div>
                      异常设备
                    </div>
                    <div class="type-num" title="45">
                      {{ ListNumber.abnormal }}
                    </div>
                  </div>
                </div>
                <!-- <div class="type-num" :title="statisticsObj.alarmProduct">
                  {{ statisticsObj.alarmProduct }}
                </div> -->
              </span>
            </a-row>
          </a-col>
          <a-col :span="6" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <div class="type-name">
                  <div>
                    <IconFont
                      type="iconzaixianshebei_huaban1"
                      style="font-size: 45px; margin-right: 10px;"
                    />
                  </div>
                  <div class="text-desc">
                    <div>
                      在线设备
                    </div>
                    <div class="type-num" title="984">
                      {{ ListNumber.online }}
                    </div>
                  </div>
                </div>
                <!-- <div class="type-num" :title="statisticsObj.productFaultRate">
                  {{ statisticsObj.productFaultRate }}
                </div> -->
              </span>
            </a-row>
          </a-col>
          <a-col :span="6" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <div class="type-name">
                  <div>
                    <IconFont
                      type="iconguzhangshuai_huaban1"
                      style="font-size: 45px; margin-right: 10px;"
                    />
                  </div>
                  <div class="text-desc">
                    <div>
                      正常设备
                    </div>
                    <div class="type-num" title="10%">
                      {{ ListNumber.failureRate }}
                    </div>
                  </div>
                </div>
                <!-- <div class="type-num" :title="statisticsObj.productFaultRate">
                  {{ statisticsObj.productFaultRate }}
                </div> -->
              </span>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="card-container">
      <div class="card-title" style="    display: flex;justify-content: space-between;">
        <div>设备筛选</div>
        <div>
          <a-badge
            status="processing" text="在线"
          />
          <a-badge
            status="warning" text="离线"
          />
        </div>
      </div>

      <div class="card-content">
        <a-form ref="detailForm" class="detail-form" :form="form">
          <a-row>
            <a-col class="search-item" :span="6">
              <a-form-item label="区域" v-bind="formItemLayout">
                <a-cascader
                  v-model="region"
                  :options="options"
                  :load-data="loadData"
                  change-on-select
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区、街道"
                  @change="changeArea"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item label="小区" v-bind="formItemLayout">
                <a-select
                  v-decorator="['estateId']"
                  allow-clear
                  show-search
                  placeholder="全部"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.housingEstate }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item
                label="系统健康状态"
                v-bind="formItemLayout"
              >
                <a-select
                  v-model="state"
                  allow-clear
                  placeholder="请选择"
                >
                  <a-select-option value="">
                    全部
                  </a-select-option>
                  <a-select-option value="0">
                    在线
                  </a-select-option>
                  <a-select-option value="1">
                    离线
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6" align="right">
              <a-button type="primary" class="mr8" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetForm">
                重置
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div
        v-if="total === 0" style="text-align: center;line-height: 60px;font-size: 12px;color: #999;    display: flex;
        justify-content: center;
        align-items: center;"
      >
        <a-icon type="frown" style="font-size: 18px;" /> <div style="padding-left: 4px;">
          暂无数据~
        </div>
      </div>
    </div>
    <div v-if="loading" style="text-align: center;">
      <a-spin />
    </div>
    <div v-else class="list-container">
      <div
        v-for="(item,index) in dataList.list" :key="index" :loading="loading" class="card" :class=" item.state === 0 ? '' : (!item.child || item.child.length === 0) ? 'itemTypes' : 'itemType'"
        style="width: 20%;"
      >
        <!--  :class="(item.flag === undefined || item.flag) && item.type === 0 ? 'beforeCard' : ''"                    (!item.child || item.child.length === 0) ? 'itemTypes' :   -->
        <div class="Before" :class="(item.flag === undefined || item.flag) && item.type === 0 ? 'beforeCard' : ''">
          <a-card
            v-show="item.flag === undefined || item.flag"
            :title="item.name"
            :class="item.state ? 'itemCard' : ''"
            style="width: 95%;margin-top: 15px;"
          >
            <span slot="extra">{{ item.estateName }}</span>

            <div style="min-height: 270px;overflow: auto;">
              <a-row>
                <a-col v-for="(items, id) in item.child" :key="id" :span="12">
                  <div>
                    <span>
                      {{ items.typeName }}
                    </span>
                    <div>
                      <div v-if="items.state === 0">
                        <span class="port normal"></span>
                        <span class="text">正常</span>
                      </div>
                      <div v-if="items.state === 1">
                        <span class="port abnormal"></span>
                        <span class="text">异常</span>
                      </div>
                    </div>
                  </div>
                  <div class="dotted"></div>
                </a-col>
                <a-col v-if="!item.child" style="padding-top: 60px;">
                  <a-empty />
                </a-col>
              </a-row>
            </div>
            <div v-show="!item.type" style="text-align:center">
              <a-button v-if="item.state === 1" type="danger" @click="handleBefore(item,index)">
                查看详情
              </a-button>
            </div>
          </a-card>
        </div>

        <div
          class="After" :class="item.flag !== undefined && !item.flag ? 'afterCard' : ''"
          style="overflow: auto;"
        >
          <div>
            <a-card
              v-show="item.flag !== undefined && !item.flag"
              :title="item.name"

              :class="item.type ? 'itemCard' : ''"
              style="width: 95%;margin-top: 15px;overflow: auto;"
            >
              <span slot="extra">{{ item.estateName }}</span>

              <div style="min-height: 270px;overflow: auto;">
                <div v-for="(beforeItem,indexs) in item.detail" :key="indexs">
                  <div>
                    {{ beforeItem.typeName }}
                  </div>
                  <div v-for="(items,id) in beforeItem.detail" :key="id" style="    line-height: 25px;">
                    <span class="port abnormal"></span>
                    <span style="margin-left:7px">{{ items.deliverySerial }}</span>
                    <span v-if="items.state === 0" style="margin-left:7px">正常</span>
                    <span v-if="items.state === 1" style="margin-left:7px">故障</span>
                  </div>
                  <div v-if="index < (beforeItem.detail.length - 1)" class="dotted"></div>
                </div>
              </div>
              <div v-show="!item.type" style="text-align:center;    padding-bottom: 30px;">
                <a-button type="danger" @click="handleBefore(item,index, showList)">
                  返回
                </a-button>
              </div>
            </a-card>
          </div>
          <!-- <div v-else>
            <a-card
              :title="item.estateName"
              :class="item.state ? 'itemCard' : ''"
              style="width: 95%;margin-top: 15px;"
            >
            </a-card>
          </div> -->
        </div>

        <div></div>
      </div>
    </div>

    <div
      v-if="noData"
      class="footer"
    >
      <span>
        {{ '共' + total + '条记录' }}
      </span>
      <a-pagination
        v-model="current"
        show-size-changer
        :page-size.sync="pageSize"
        :total="total"
        @showSizeChange="onShowSizeChange"
        @change="handleTableChange"
      />
    </div>
  </div>
</template>

<script>
import {
  getArea,
  getEstate,
  iconFontComponent
} from '@/components/mixins/mixins.js'
// getProductList,
import { getDashboard, getHealthyList, getyHealthyDetail, getHealthyCount } from '@/api/deviceOrder'
import Vue from 'vue'
export default {
  mixins: [getArea, getEstate, iconFontComponent],
  data () {
    return {
      form: this.$form.createForm(this, {}),
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      loading: false,
      current: 1,
      pageSize: 10,
      total: 0,
      region: [],
      dataList: [
        {
          type: 0,
          equipmentType: '智能垃圾箱',
          plot: '清水湾花园',
          mouth: 1,
          door: 0,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 0,
          led: 0,
          net: 1,
          benchscale: 0,
          flag: true,
          detials: [
            {
              text: '设备投口',
              desc: ['1-2 投口故障', '1-4 投口故障']
            },
            {
              text: '内部灯光',
              desc: ['灯光故障']
            },
            {
              text: '台秤',
              desc: ['1-4台秤故障']
            }
          ]
        }, {
          type: 0,
          equipmentType: '智能回收站',
          plot: '东秦新苑',
          mouth: 1,
          door: 0,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 0,
          led: 0,
          net: 1,
          benchscale: 0,
          flag: true,
          detials: [
            {
              text: '设备投口',
              desc: ['1-2 投口故障', '1-4 投口故障']
            },
            {
              text: '内部灯光',
              desc: ['灯光故障']
            },
            {
              text: '台秤',
              desc: ['1-4台秤故障']
            }
          ]
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '清水湾花园',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1,
          led: 1,
          net: 1,
          benchscale: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '清水湾花园',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1,
          led: 1,
          net: 1,
          benchscale: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '东秦新苑',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1,
          led: 1,
          net: 1,
          benchscale: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '东秦新苑',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1,
          led: 1,
          net: 1,
          benchscale: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '东秦新苑',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1,
          led: 1,
          net: 1,
          benchscale: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '东秦新苑',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1,
          led: 1,
          net: 1,
          benchscale: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '金尧华府',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1,
          led: 1,
          net: 1,
          benchscale: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '金尧华府',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1,
          led: 1,
          net: 1,
          benchscale: 1
        }
      ],
      isTop: false,
      statisticsObj: {},
      turnOver: [],
      ListNumber: {},
      num: '',
      state: '',
      showList: true, // 反转判断
      noData: false
    }
  },
  mounted: function () {
    this.load()
    this.getHealthyCount()
    this.getProductList()
  },
  methods: {
    handleBefore (item, index) {
      Vue.ls.set('indexs', index)
      item.show = !item.show
      // console.log(item.show)
      this.getyHealthyDetail(item.id, index)
      item.flag = !item.flag
      const indexs = Vue.ls.get('indexs', indexs)
      const element = document.getElementsByClassName('card')[index]
      if (element.style.transform === 'rotateY(180deg)') {
        element.style.transform = 'rotateY(0deg)'
      } else {
        element.style.transform = 'rotateY(180deg)'
      }
    },
    load () {
      this.getArea('', 2)
      this.getEstate()
      this.total = this.dataList.length
      // this.getDashboard()
      // this.getProductList()
    },
    getDashboard () {
      const params = {}
      getDashboard(params).then(res => {
        const result = res.result
        if (res.code === 0) {
          this.statisticsObj = result
        }
      })
    },
    // 数量
    getHealthyCount () {
      const params = {
        type: 1
      }
      getHealthyCount(params).then(res => {
        this.ListNumber = res.result
      })
    },
    getProductList () {
      const params = {
        page: this.current,
        pageSize: this.pageSize,
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        estateId: this.form.getFieldValue('estateId'),
        type: 1,
        state: this.state
      }
      params.streetId = this.region[3] || ''
      this.noData = false
      this.loading = true
      getHealthyList(params).then(res => {
        const result = res.result
        this.loading = false
        if (result.list.length > 0) {
          this.noData = true
        }
        result.list.forEach(val => {
          val.flag = true
          return {
            ...val,
            flag: true
          }
        })
        this.dataList = result

        this.total = result.totalCount
      })
    },

    // 列表详情
    getyHealthyDetail (val) {
      this.num = val.id
      const parmes = {
        id: val
      }
      getyHealthyDetail(parmes).then((res, index) => {
        this.turnOver = res.result
      })
    },
    changeArea (areasId) {
      this.estateList = []
      this.form.setFieldsValue({ estateId: undefined })
      if (areasId.length < 4) {
        this.getEstate(areasId)
      } else if (areasId.length === 4) {
        this.getEstate(null, areasId[3])
      }
    },
    toSearch () {
      // this.dataList = {}

      this.current = 1
      const params = {
        page: this.current,
        pageSize: this.pageSize,
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        estateId: this.form.getFieldValue('estateId'),
        type: 1,
        state: this.state
      }
      params.streetId = this.region[3] || ''
      this.loading = true
      getHealthyList(params).then(res => {
        // console.log(res, 'res')
        this.loading = false
        const result = res.result

        result.list.forEach((val, index) => {
          const element = document.getElementsByClassName('card')[index]
          if (element) {
            element.style.transform = 'rotateY(0deg)'
          }

          val.show = false
          val.flag = true
          return {
            ...val,
            flag: true,
            show: false
          }
        })
        const dataList = result
        this.dataList = dataList
        // console.log(this.dataList.list[0].flag)
        this.total = result.totalCount
      })
    },
    resetForm () {
      this.form.resetFields()
      this.region = []
      this.state = ''
      this.form.setFieldsValue({ estateId: undefined })
      this.getProductList()
      this.getEstate()
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onShowSizeChange (current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getProductList()
    },
    handleTableChange (current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getProductList()
    }
  }
}
</script>

<style lang="css" scoped>
.itemColor {
  color: #b3b3b3;
}
  .list-container{
    perspective:2000px;
  }
  .card{
    transition: transform 0.5s;
    transform-style: preserve-3d;
  }
  .After{
    transform: rotateY(180deg);
  }
</style>

<style lang="stylus" scoped>
.footer
  padding 35px 0px
  display flex
  justify-content center
  align-items center
  span
    padding-right 7px
.list-container >>> .ant-card-body
  height 350px
.list-container >>> .ant-btn-danger
  background-color rgba(255, 186, 0, 1)
  border-color rgba(255, 186, 0, 1)
.list-container >>> .ant-card-head
  min-height 0
  background rgba(24, 144, 255, 1)
  color white
  padding 0 20px
  .ant-card-head-title
    font-size 15px
    padding 12px 0
  .ant-card-extra
    color white
    padding 12px 0
.list-container
  width 100%
  display flex
  flex-wrap wrap
  .itemType >>> .ant-card-head
    background rgba(255, 186, 0, 1)
  .itemTypes >>> .ant-card-head
    background #B3B3B3
  .ant-row
    width 95%
    text-align center
  .dotted
    border-bottom 1px dashed #b7b7b7
    margin: 15px 0;
  .port
    width 7px
    height 7px
    border-radius 50%
    display inline-block
  .normal
    background rgba(24, 144, 255, 1)
  .text
    margin-left 7px
    font-size 12px
  .abnormal
    background rgba(255, 186, 0, 1)
.card-container
  .card-title
    span
      font-weight normal
      margin-left 30px
      font-size 15px
.panel-container
  margin-bottom 25px
.height-90
  height 90px
  position relative
  .type-name
    color #666666
    font-size 12px
    margin-top 16px
    display flex
    align-items center
    .text-desc
      display flex
      flex-direction column
      align-items center
      div:nth-child(1)
        font-size 14px
        font-weight 600
  .type-num
    font-size 24px
    color #333333
    margin-top 8px
    text-align left
</style>
